import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full py-16 bg-white flex justify-center" data-id="element-290">
      <div className="max-w-3xl mx-auto px-6" data-id="element-291">
        <div className="bg-[#14B8A6] rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-292">
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-white/10 rounded-full blur-3xl" data-id="element-293"></div>
          <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-black/10 rounded-full blur-3xl" data-id="element-294"></div>

          <div className="relative z-10 flex flex-col items-center" data-id="element-295">
            <div className="bg-white text-[#14B8A6] p-4 rounded-full mb-6 shadow-lg" data-id="element-296">
              <ShieldCheck className="w-12 h-12" data-id="element-297" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-298">
              30-Day "Taste Paradise or It's Free" Guarantee
            </h2>
            <p className="text-lg md:text-xl text-white/90 leading-relaxed max-w-2xl mb-4" data-id="element-299">
              Cook 3 recipes from the playbook. If you don't taste paradise on
              your plate, email us within 30 days for a full refund — and{' '}
              <strong className="text-yellow-300" data-id="element-300">
                keep the PDF anyway as our gift
              </strong>
              . No questions, no hoops.
            </p>
            <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-bold border border-white/20" data-id="element-301">
              You can't lose. We take all the risk.
            </div>
          </div>
        </div>
      </div>
    </section>;
}